// src/app/services/drainPanApi.ts
import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './apiConfig';
import { IDrainPan, IDrainPanParams, UpdatePayload } from '../models';

export const drainPanApi = createApi({
  reducerPath: 'drainPanApi',
  baseQuery,
  endpoints: (builder) => ({
    getDrainPanParams: builder.query<{ drain_pan: IDrainPanParams }, void>({
      query: () => `/api/v1.0/cms/1/v1.0.0/ahu/drain_pan/params/?type_id=1`,
      keepUnusedDataFor: Infinity, // Keep the cached data until the page reloads
    }),
    getDrainPan: builder.query<IDrainPan, number>({
      query: (id) => `/api/v1.0/ahu/drain_pans/${id}`,
    }),
    getDrainPanAvaibleSections: builder.query<{ section_type: string }[], void>(
      {
        query: () => `/api/v1.0/cms/1/v1.0.0/ahu/drain_pan/available_sections/`,
      }
    ),
    updateDrainPan: builder.mutation<IDrainPan, UpdatePayload<IDrainPan>>({
      query: ({ id, body, signal }) => ({
        url: `/api/v1.0/ahu/drain_pans/${id}`,
        method: 'PATCH',
        body,
        signal,
      }),
    }),
    createDrainPan: builder.mutation<any, UpdatePayload<{ section_id: number }>>({
      query: ({ body, signal }) => ({
        url: `/api/v1.0/ahu/drain_pans/`,
        method: 'POST',
        body,
        signal,
      }),
    }),
  }),
});

export const {
  useLazyGetDrainPanQuery,
  useGetDrainPanParamsQuery,
  useGetDrainPanAvaibleSectionsQuery,
  useUpdateDrainPanMutation,
  useCreateDrainPanMutation,
} = drainPanApi;

// Drain Pan API service - helpers moved to apiHelpers.ts